import { Text } from '@ekhodealer/ekho-common/rev';

import type { DiscountMethod } from '@ekhodealer/ekho-common';

export interface MethodCellProps {
	method: DiscountMethod;
}

export const MethodCell = ({ method }: MethodCellProps) => {
	return <Text size='bodySmall'>{method}</Text>;
};
